var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.contentPresent
    ? _c(
        "div",
        {
          staticClass:
            "border border-primary-500 rounded-full px-2 text-gray-800 bg-white max-w-full chipHeight inline-flex items-center mb-1 mr-1",
          attrs: { title: _vm.chipContent },
        },
        [
          _c("span", { staticClass: "truncate text-xs" }, [
            _vm._v(_vm._s(_vm.chipContent)),
          ]),
        ]
      )
    : _c("div", [_vm._v(" " + _vm._s(_vm.chipContent) + " ")])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }